export default "__VITE_ASSET__e0IKqBOO__"